"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Observer = function () {
    /**
     * Beobachter
     * @type {string}
     
    Observer*/

    function Observer(observers, id, request) {
        _classCallCheck(this, Observer);

        if (observers && observers.length && observers.length > 0) {
            this.Observers = observers;
        }
        if (id && id.length && id.length > 0) {
            this.Id = id;
        }
        if (request) {
            this.request = request;
        }
    }
    /**
     * updates all registered observers
     * @constructor
     */

    _createClass(Observer, [{
        key: "SetRequest",
        value: function SetRequest(request) {
            this.request = request;
        }
    }, {
        key: "Notify",
        value: function Notify(observer) {
            this.Observers.forEach(function (currentElement) /*currentIndex, referenceToArray*/{
                if (currentElement.Update) {
                    currentElement.Update(observer);
                }
            });
        }
    }]);

    return Observer;
}();

exports.default = Observer;